import { faLock } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "antd";
import { string } from "prop-types";
import { useIntl } from "react-intl";
import { ProjectTitleText, ProjectTitleWrapper } from "../styled";

interface IProps {
  projectName: string;
  projectNumber: string;
  isSecure: boolean;
}

export const ProjectTitle = ({
  projectNumber,
  projectName,
  isSecure,
}: IProps) => {
  const intl = useIntl();

  return (
    <ProjectTitleWrapper>
      <ProjectTitleText>
        {isSecure && (
          <Tooltip
            title={intl.formatMessage({ id: "project.isSecureMessage" })}
            trigger={["hover"]}
          >
            <FontAwesomeIcon icon={faLock} className="mr-2" />
          </Tooltip>
        )}
        {projectNumber} - {projectName}
      </ProjectTitleText>
    </ProjectTitleWrapper>
  );
};

ProjectTitle.propTypes = {
  projectName: string,
  projectNumber: string,
  isSecure: string,
};
